import { filterOrganizationTreeItems } from '../../../../../../backend/features/organizations/shared';
import { collectOrgIdsForAnyOrgPermission } from '../../../../../../backend/features/permissions/shared';
export function filterOrganizationTreeItemsByFieldFilter(organizations, filter, userState, orgMembershipCountMap) {
    if (filter.length > 0) {
        const search = filter.find((f) => f.field === 'search');
        const pending = filter.find((f) => f.field === 'pending');
        let searchQuery;
        if (search) {
            searchQuery = search.value.trim().toLowerCase();
        }
        const highlightedOrganizationIds = new Set();
        const organizationTreeItems = filterOrganizationTreeItems(organizations, (item) => {
            if (searchQuery && item.name.toLowerCase().indexOf(searchQuery) === -1) {
                return false;
            }
            if (pending && !(orgMembershipCountMap === null || orgMembershipCountMap === void 0 ? void 0 : orgMembershipCountMap.get(item.id.split('_')[0]))) {
                return false;
            }
            if (userState) {
                const permission = filter.find((f) => f.field === 'permission');
                const permissionManage = permission && permission.value === 'manage';
                const permissionMember = permission && permission.value === 'member';
                if (permission &&
                    permissionManage &&
                    !collectOrgIdsForAnyOrgPermission(userState, 'view-and-message-members', 'create-notifications', 'manage-members', 'manage-organization').includes(item.id.split('_')[0])) {
                    return false;
                }
                if (permission && permissionMember && !userState.orgMembership.includes(item.id.split('_')[0])) {
                    return false;
                }
            }
            highlightedOrganizationIds.add(item.id);
            return true;
        });
        return {
            organizations: organizationTreeItems,
            highlightedOrganizationIds: Array.from(highlightedOrganizationIds),
        };
    }
    else {
        return {
            organizations: organizations,
            highlightedOrganizationIds: [],
        };
    }
}
